export const EVENTS_GET_ALL_EVENT = "EVENTS_GET_ALL_EVENT";
export const EVENTS_ADD_NEW_EVENT = "EVENTS_ADD_NEW_EVENT";
export const EVENTS_UPDATE_EVENT = "EVENTS_UPDATE_EVENT";
export const EVENTS_DELETE_EVENT = "EVENTS_DELETE_EVENT";
export const EVENTS_UPDATE_USSD_ID = "EVENTS_UPDATE_USSD_ID";
export const EVENTS_GET_EVENT_BY_TYPE = "EVENTS_GET_EVENT_BY_TYPE";
export const EVENTS_GET_TICKET_DETAILS = "EVENTS_GET_TICKET_DETAILS";
export const EVENTS_APPROVE_TICKET = "EVENTS_APPROVE_TICKET";
export const EVENTS_SEARCH_TICKET = "EVENTS_SEARCH_TICKET";
export const EVENTS_GET_ALL_PRE_SELL_TICKETS = "EVENTS_GET_ALL_PRE_SELL_TICKETS";
export const EVENTS_DELETE_PRE_SELL_TICKET = "EVENTS_DELETE_PRE_SELL_TICKET";
export const EVENTS_DOWNLOAD_PRE_SELL_TICKET = "EVENTS_DOWNLOAD_PRE_SELL_TICKET";
export const EVENTS_ACTIVATE_TICKET = "EVENTS_ACTIVATE_TICKET";
export const EVENTS_DOWNLOAD_INVITATION_TICKET = "EVENTS_DOWNLOAD_INVITATION_TICKET";
export const EVENTS_TOGGLE_PRE_SELL_TICKET_STATUS = "EVENTS_TOGGLE_PRE_SELL_TICKET_STATUS";
export const EVENTS_GET_ALL_INVITATION_TICKETS = "EVENTS_GET_ALL_INVITATION_TICKETS";
export const EVENTS_DELETE_INVITATION_BATCH = "EVENTS_DELETE_INVITATION_BATCH";
export const EVENTS_TOGGLE_INVITATION_BATCH_STATUS = "EVENTS_TOGGLE_INVITATION_BATCH_STATUS";
export const EVENTS_DOWNLOAD_INVITATION_BATCH = "EVENTS_DOWNLOAD_INVITATION_BATCH";
export const EVENTS_DELETE_INVITATION_TICKET = "EVENTS_DELETE_INVITATION_TICKET";
export const EVENTS_DELETE_MULTIPLE_INVITATION_TICKETS = "EVENTS_DELETE_MULTIPLE_INVITATION_TICKETS";
export const EVENTS_GET_BOOKING_FORM_DATA = "EVENTS_GET_BOOKING_FORM_DATA";
export const EVENTS_DELETE_EVENT_TICKET = "EVENTS_DELETE_EVENT_TICKET";
export const EVENTS_RESEND_TICKET_SMS = "EVENTS_RESEND_TICKET_SMS";
export const EVENTS_DELETE_BOOKING = "EVENTS_DELETE_BOOKING";